import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useResetPassword from "../Hooks/useResetPassword";

const ResetPasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { confirmNewPassword, loading } = useResetPassword();
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState(null);

  // Extract token from query parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const UID = searchParams.get("uid");

  // Handle form submission for resetting the password
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    
    const response = await confirmNewPassword(token, password,UID);
    
    if (response?.success) {
      navigate("/login");
    } else {
      setErrorMessage(response?.message || "Failed to reset password. Please try again.");
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/forgot-password");
    }
  }, [token, navigate]);

  return (
    <div className="flex justify-center flex-col items-center">
      <div className="d-flex w-full bg-gray-50 p-3">
        <h2 className="text-xl font-bold text-center">Reset Password</h2>
      </div>
      <div className="w-full max-w-md p-6 my-16 rounded-lg">
        <p className="text-xl font-semibold mb-5 uppercase">Enter New Password</p>
        <form onSubmit={handleSubmit}>
          {/* Password Field */}
          <div className="relative mb-6">
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
              required
            />
            <label
              htmlFor="password"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${password ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              New Password <span className="text-red-500">*</span>
            </label>
          </div>

          {/* Confirm Password Field */}
          <div className="relative mb-6">
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
              required
            />
            <label
              htmlFor="confirmPassword"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${confirmPassword ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              Confirm Password <span className="text-red-500">*</span>
            </label>
          </div>

          {/* Display Error Message */}
          {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}

          <button
            type="submit"
            className={`w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Resetting Password..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
